/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationStoreProductDataFromJSON, FxIdApplicationStoreProductDataToJSON, } from './FxIdApplicationStoreProductData';
import { FxIdApplicationStorePriceDataFromJSON, FxIdApplicationStorePriceDataToJSON, } from './FxIdApplicationStorePriceData';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreDataResponseProductWithPrice interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreDataResponseProductWithPrice(value) {
    if (!('Product' in value) || value['Product'] === undefined)
        return false;
    if (!('Price' in value) || value['Price'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreStoreDataResponseProductWithPriceFromJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseProductWithPriceFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseProductWithPriceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Product': FxIdApplicationStoreProductDataFromJSON(json['Product']),
        'Price': FxIdApplicationStorePriceDataFromJSON(json['Price']),
    };
}
export function FxIdWebFeaturesStoreStoreDataResponseProductWithPriceToJSON(json) {
    return FxIdWebFeaturesStoreStoreDataResponseProductWithPriceToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataResponseProductWithPriceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Product': FxIdApplicationStoreProductDataToJSON(value['Product']),
        'Price': FxIdApplicationStorePriceDataToJSON(value['Price']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreStoreDataResponseProductWithPrice.js.map